import {
  PlateType,
  PlateTypesParamType,
} from '@/common/queries/selections/plateType/plateType.type';
import { fetchApi } from '@/config/axiosSetting';

export const getPlateTypeFunction = (
  param: PlateTypesParamType,
): Promise<PlateType[]> => {
  return fetchApi.get('/selection_item/plate_type/wop_list/', {
    params: { type: param?.type, insurance: param?.insurance },
  });
};
